(function () {
  if (customElements.get('bm-innovations-carousel')) return;

  class BmInnovationsCarousel extends HTMLElement {
    connectedCallback() {
      const row = this.querySelector('[data-bic-row]');
      if (!row) return;
      this.initRow(row);
    }

    initRow(row) {
      const carousel = row.querySelector('[data-bic-carousel]');
      if (!carousel) return;

      const slides = Array.from(carousel.querySelectorAll('[data-bic-slide]'));
      const dotsContainer = row.querySelector('[data-bic-dots]');
      const dots = dotsContainer
        ? Array.from(dotsContainer.querySelectorAll('[data-bic-dot]'))
        : [];
      const cardsPerPage = dotsContainer
        ? parseInt(dotsContainer.getAttribute('data-bic-cards-per-page'), 10) || 1
        : 1;
      const total = slides.length;
      const pageCount = dots.length;
      if (total <= 1 || pageCount <= 1) return;

      let activePage = 0;

      const setActive = (pageIdx) => {
        activePage = ((pageIdx % pageCount) + pageCount) % pageCount;
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activePage));
      };

      const scrollToPage = (pageIdx) => {
        const slideIdx = Math.min(pageIdx * cardsPerPage, total - 1);
        const target = slides[slideIdx];
        if (!target) return;
        carousel.scrollTo({
          left: target.offsetLeft - carousel.offsetLeft,
          behavior: 'smooth',
        });
      };

      const goToPage = (pageIdx) => {
        const wrapped = ((pageIdx % pageCount) + pageCount) % pageCount;
        setActive(wrapped);
        scrollToPage(wrapped);
      };

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => goToPage(i));
      });

      const observer = new IntersectionObserver(
        (entries) => {
          let bestEntry = null;
          for (const entry of entries) {
            if (entry.isIntersecting) {
              if (!bestEntry || entry.intersectionRatio > bestEntry.intersectionRatio) {
                bestEntry = entry;
              }
            }
          }
          if (bestEntry) {
            const slideIdx = slides.indexOf(bestEntry.target);
            if (slideIdx < 0) return;
            const pageIdx = Math.floor(slideIdx / cardsPerPage);
            if (pageIdx !== activePage) setActive(pageIdx);
          }
        },
        { root: carousel, threshold: 0.6 },
      );
      slides.forEach((slide) => observer.observe(slide));
    }
  }

  customElements.define('bm-innovations-carousel', BmInnovationsCarousel);
})();
